// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.a_cursor[data-v-1fb71d49] {cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
